import { render, staticRenderFns } from "./UserEditCard.vue?vue&type=template&id=a67e0e2e&scoped=true"
import script from "./UserEditCard.vue?vue&type=script&lang=js"
export * from "./UserEditCard.vue?vue&type=script&lang=js"
import style0 from "./UserEditCard.vue?vue&type=style&index=0&id=a67e0e2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67e0e2e",
  null
  
)

export default component.exports